import bugsnag from "@bugsnag/js";
import bugsnagReact from "@bugsnag/plugin-react";
import React, { FunctionComponent, ReactNode } from "react";
import { getMetaContent } from "@Utils/meta";

const releaseStage = getMetaContent("cheerz-env");
const appVersion = getMetaContent("cheerz-front-release");

bugsnag.start({
  apiKey: "0dcb931ee6df4c320d89f75e1dcdd6c2",
  appVersion,
  enabledReleaseStages: ["production", "staging"],
  plugins: [new bugsnagReact(React)],
  releaseStage,
});

export const BugsnagErrorBoundary = bugsnag.getPlugin("react")?.createErrorBoundary(React);

export const WithBugsnag: FunctionComponent<{ children: ReactNode }> = ({ children }) => {
  return BugsnagErrorBoundary ? (
    <BugsnagErrorBoundary>{children}</BugsnagErrorBoundary>
  ) : (
    <>{children}</>
  );
};
